export default "__VITE_ASSET__BhMkRgZD__"